import createClient, { type Middleware } from 'openapi-fetch'
import { getToken } from '@/api/auth'
import { generateRequestId } from '@/api/request-id'
import type { paths } from '@/api/types'

const DEFAULT_BASE_URL = 'http://localhost:8001/api/v1'
export const baseUrl = import.meta.env.VITE_API_BASE_URL ?? DEFAULT_BASE_URL

const requestMiddleware: Middleware = {
  async onRequest({ request }) {
    const headers = new Headers(request.headers)
    headers.set('X-Request-ID', generateRequestId())
    if (!headers.has('Accept')) {
      headers.set('Accept', 'application/json')
    }

    // Bearer token csak a saját API-host-ra (DEC-FE-004 / DEC-FE-013):
    // a fetch wrapper kliensoldalon megakadályozza, hogy a token
    // véletlenül 3rd-party origin-re menjen.
    if (request.url.startsWith(baseUrl)) {
      const token = getToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
    }

    return new Request(request, { headers })
  },
}

export const apiClient = createClient<paths>({ baseUrl })
apiClient.use(requestMiddleware)
